import {
    NumberParam,
    withDefault,
    createEnumParam,
    useQueryParams,
} from "use-query-params";
import { AccountingReportCycle } from "@common/constants";
import { DateOnlyParam } from "@helpers/dateOnlyParam";

interface ReportParams {
    entityId?: number;
    cycle?: AccountingReportCycle;
    start?: Date;
    end?: Date;
}

export function useReportParams(): ReportParams {
    const [params] = useQueryParams({
        entityId: withDefault(NumberParam, undefined),
        cycle: withDefault(
            createEnumParam(Object.values(AccountingReportCycle)),
            undefined,
        ),
        start: withDefault(DateOnlyParam, undefined),
        end: withDefault(DateOnlyParam, undefined),
    });

    return params;
}
